import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

const DEFAULT_MODES = [["explore", "Explore"], ["text", "Read as text"]];

export const ViewToggle = ({ mode, onMode, testid, modes = DEFAULT_MODES }) => (
  <div role="group" aria-label="View mode" className="inline-flex self-start border border-o-line p-0.5">
    {modes.map(([v, l]) => (
      <button
        key={v}
        type="button"
        aria-pressed={mode === v}
        onClick={() => onMode(v)}
        data-testid={`${testid}-mode-${v}`}
        className={cn(
          "px-3 py-1.5 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors",
          mode === v ? "bg-o-text text-o-bg" : "text-o-dim hover:text-o-text"
        )}
      >
        {l}
      </button>
    ))}
  </div>
);

export const ExplorerFrame = ({ testid, label, hint, mode, onMode, modes, className, children }) => (
  <div data-testid={testid} className={cn("border border-o-strong bg-o-surface", className)}>
    <div className="flex flex-col gap-4 border-b border-o-line px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div>
        <p className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-o-accent">{label}</p>
        {hint && <p className="mt-1 max-w-xl text-sm text-o-dim">{hint}</p>}
      </div>
      {onMode && <ViewToggle mode={mode} onMode={onMode} testid={testid} modes={modes} />}
    </div>
    {children}
  </div>
);

export const Swap = ({ k, className, children }) => {
  const reduce = useReducedMotion();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={k}
        className={className}
        initial={reduce ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={reduce ? { opacity: 0 } : { opacity: 0, y: -6 }}
        transition={{ duration: 0.22 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
